<template>
  <div>
    <div class="section">
      <div class="post">
        <span>申请本协会</span>
        <apply-name tag="h5"/>
      </div>
      <div class="money">
        <span>缴费金额：</span>
        <pay-fee-amount/>
      </div>
      <div class="label">
        <div class="label-title">
          银行流水号
          <span class="red">*</span>
        </div>
        <div class="input">
          <input type="text" placeholder="请输入转账银行流水号" v-model="paymentData.tradeNo">
        </div>
      </div>
      <invoice :invoice-info="invoiceInfo" ref="invoiceForm"/>
    </div>
    <button class="btn-main btn-submit" @click="invoiceApply" :disabled="isSubmit">确定支付</button>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
import VDistpicker from '@/components/distpicker.vue'
import ApplyName from '@/components/member/ApplyName.vue'
import Invoice from '@/components/member/Invoice.vue'
import PayFeeAmount from '@/components/member/PayFeeAmount.vue'
export default {
  components: {
    'footer-logo': footerLogo,
    VDistpicker,
    ApplyName,
    PayFeeAmount,
    Invoice
  },
  data() {
    return {
      invoiceType: 1,
      isSubmit: false,
      invoiceInfo: {},
      paymentData: {
        orderMoney: this.$route.query.amount,
        tradeNo: ''
      }
    }
  },
  created() {},
  methods: {
    invoiceApply() {
      var _this = this
      if (this.validNull(this.paymentData.tradeNo)) {
        this.$dialog.toast({
          mes: '请填写交易流水号',
          timeout: 1500
        })
        return
      }

      if (!this.$refs.invoiceForm.check()) {
        return
      }
      this.isSubmit = true

      var postData = {
        number: this.paymentData.tradeNo,
        invoice: {
          isRequired: this.invoiceInfo.isRequired,
          name: this.invoiceInfo.Name,
          title: this.invoiceInfo.Title,
          taxNumber: this.invoiceInfo.TaxNum,
          Adddress: this.invoiceInfo.Address,
          Telephone: this.invoiceInfo.Telephone
        }
      }

      this.$post('/api/OrganizationEnterprise/SubmitOfflineProfile', postData)
        .then(result => {
          this.$router.push({ path: '/member/pay/remit-confirm' })
        })
        .catch(result => {
          this.isSubmit = false
          this.$dialog.toast({
            mes: result.Error.Message,
            timeout: 1500
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
.section {
  width: 100%;
  height: auto;
  background: #fff;
  padding-bottom: 20 / @rem-size;

  .section-title {
    background: #f7f7f7;
    padding-left: 35 / @rem-size;
    line-height: 80 / @rem-size;
    font-size: 28 / @rem-size;
    color: #999999;
  }

  .label {
    width: 100%;
    padding: 25 / @rem-size 24 / @rem-size 0;

    .label-title {
      font-size: 28 / @rem-size;
      color: #333;
    }

    .money {
      color: #ff3939;
      font-size: 28 / @rem-size;
      margin-top: 15 / @rem-size;

      span {
        display: inline;
        padding: 0;
      }
    }

    .radio-group {
      display: block;
      margin-top: 15 / @rem-size;

      .radio {
        display: block;
        line-height: 80 / @rem-size;
        font-size: 28 / @rem-size;
        color: #3e3e3e;
        position: relative;
        box-sizing: border-box;
        padding-left: 50 / @rem-size;
        float: left;
        margin-left: 50 / @rem-size;

        &:first-child {
          margin-left: 0;
        }

        i {
          display: block;
          width: 34 / @rem-size;
          height: 32 / @rem-size;
          background: url('../../assets/images/radio-checkbox-bg.png') 0 0 no-repeat;
          background-size: cover;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          background-position: -34 / @rem-size 0;
        }

        input[type='radio'] {
          -webkit-appearance: none !important;
          display: none;

          &:checked {
            + i {
              background-position: 0 0;
            }
          }
        }
      }
    }

    .checkbox-group {
      display: block;
      margin-top: 15 / @rem-size;

      .checkbox {
        display: block;
        line-height: 80 / @rem-size;
        font-size: 28 / @rem-size;
        color: #3e3e3e;
        position: relative;
        box-sizing: border-box;
        padding-left: 50 / @rem-size;
        float: left;
        margin-left: 50 / @rem-size;

        &:first-child {
          margin-left: 0;
        }

        i {
          display: block;
          width: 34 / @rem-size;
          height: 32 / @rem-size;
          background: url('../../assets/images/radio-checkbox-bg.png') 0 0 no-repeat;
          background-size: cover;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          background-position: -34 / @rem-size 0;
        }

        input[type='checkbox'] {
          -webkit-appearance: none !important;
          display: none;

          &:checked {
            + i {
              background-position: 0 0;
            }
          }
        }
      }
    }

    .select-group {
      height: 80 / @rem-size;
      margin-top: 15 / @rem-size;
    }

    .select {
      width: 100%;
      height: 80 / @rem-size;
      margin-top: 15 / @rem-size;
      position: relative;

      i {
        display: block;
        width: 20 / @rem-size;
        height: 14 / @rem-size;
        background: url('../../assets/images/select-icon.png');
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 24 / @rem-size;
        margin: auto;
      }

      select {
        width: 100%;
        height: 100%;
        background: #f7f7f7;
        border-radius: 8 / @rem-size;
        padding: 0 20 / @rem-size;
      }
    }
  }
}

.btn-submit {
  display: block;
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  margin: auto;
  margin-top: 35 / @rem-size;
  border-radius: 8 / @rem-size;
  font-size: 36 / @rem-size;
}

.section {
  .post,
  .money {
    span {
      display: block;
      font-size: 28 / @rem-size;
      padding: 30 / @rem-size 24 / @rem-size 0;
      color: #999;
    }

    h5 {
      color: #333;
      font-size: 36 / @rem-size;
      padding: 0 24 / @rem-size;
      line-height: 88 / @rem-size;
      font-weight: normal;
    }

    h4 {
      color: #ff3939;
      font-size: 48 / @rem-size;
      padding: 0 24 / @rem-size;
      line-height: 88 / @rem-size;
      font-weight: normal;

      span {
        display: inline;
        padding: 0;
        color: #ff3939;
      }
    }
  }

  .money {
    span {
      padding-top: 5 / @rem-size;
    }
  }

  .pay {
    padding: 0 24 / @rem-size;
    margin-top: 15 / @rem-size;

    i {
      display: block;
      width: 50 / @rem-size;
      height: 50 / @rem-size;
      background-image: url('../../assets/images/wx-pay.png');
      background-size: 100% 100%;
      float: left;
    }

    span {
      float: left;
      line-height: 50 / @rem-size;
      color: #333;
      padding-top: 0;
    }
  }
}

.mat-30 {
  margin-top: 30 / @rem-size;
}
</style>
